import { Typography } from "@mui/material";
import { useMemo } from "react";

import { PrescriptionCard } from "./PrescriptionCard";

export interface IPrescriptionPrescriberCardProps {
  name?: string;
  email?: string;
  phone?: string;
}

export const PrescriptionPrescriberCard = ({
  name,
  email,
  phone,
}: IPrescriptionPrescriberCardProps) => {
  const persistedStyle = useMemo(
    () => ({
      className: "break-words",
      sx: { fontWeight: 600 },
    }),
    []
  );
  const prescriberInformation = useMemo(
    () => [
      {
        label: "Name",
        value: <Typography {...persistedStyle}>{name ?? "N/A"}</Typography>,
      },
      {
        label: "Email",
        value: <Typography {...persistedStyle}>{email ?? "N/A"}</Typography>,
      },
      {
        label: "Phone",
        value: <Typography {...persistedStyle}>{phone ?? "N/A"}</Typography>,
      },
    ],
    [email, name, persistedStyle, phone]
  );

  return (
    <PrescriptionCard
      title="Prescriber Information"
      items={prescriberInformation}
    />
  );
};
